module.exports = __webpack_public_path__ + "img/stackslash-process-8.ed00ef8f.jpg";